<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style lang="scss">
  @import "./style/main.scss";
html {
  min-width: 1200px;
  background-color: #f5f7f9;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.form-footer{
  margin-top: 10px;
}
.text-red{
  color: red;
}
.mask{
	width: 100vw;
	height: 100vh;
	background: rgba($color: #000000, $alpha: 0.5);
	position: fixed;
	z-index: 1500;
	left: 0;
	top: 0;
}
</style>
